export const PRODUCT_CODES = [
  'HomePlus',
  'CompleteMyHome',
  'SmartHomeSupport',
  'VerizonProtectHome',
  'VerizonProtectHomeFios',
  'Test',
] as const;

export const PARTNER_CODES = ['Asurion', 'TechCoachHome', 'Sprint', 'Verizon', 'Test'] as const;



// WEBPACK FOOTER //
// ./packages/smart-home-support/partner/constants.ts